require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./about-us-member-testimonials.json") })
        }
      }, "path---about-us-member-testimonials");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---about-us-member-testimonials!./.cache/json/about-us-member-testimonials.json
// module id = 1544
// module chunks = 231608221292675